export class LiteMenuDto{
    id: number;
    active?: boolean;
    name?: string;
    priceBracketId?: number;
    menuMenuCategories?: [{
        id: number;
        name: string;
        menuCategoryItems: [
            {
                id: number;
                product: {
                    id: number;
                    name: string;
                    price: number;
                }
            }
        ];
    }];
    merchant?: {
        id: number;
        name: string;
        currency?: {
            id: string;
            name: string;
            code: string;
        }
    }
}